/* eslint-disable max-lines */
/* eslint-disable max-len */
/* eslint-disable camelcase */
/* eslint-disable new-cap */
import * as CryptoJS from 'crypto-js';
import { debugInfo } from '../debug';
import {
    baseUrl,
    baseUserInfoUrl,
    mintApi,
    tokenApi,
    userInfoApi,
} from './url';
import {
    clientIdConfig,
    clientSecretConfig,
    codeChallengeMethodConfig,
    grantTypeConfig,
    promptConfig,
    responseTypeConfig,
    scopeConfig,
} from './config';
import { getTokenApi, getUrlCodeApi, getUserDataApi, handelGetUrl } from './apiHelper';
import { handelUserInfoData } from './mappingHelper';

function generateRandomString() {
    const chars =
        '0123456789ABCDEFGHIJKLMNOPQRSTUVWXTZabcdefghiklmnopqrstuvwxyz-_.~';
    const stringLength = 43;
    let randomString = '';
    for (let i = 0; i < stringLength; i++) {
        const randomNum = Math.floor(Math.random() * chars.length);
        randomString += chars.substring(randomNum, randomNum + 1);
    }

    return randomString;
}

function codeChallengeGenerator(randomString: string) {
    let codeChallenge = '';
    if (CryptoJS) {
        const hash = CryptoJS.SHA256(randomString);
        const base64Code = CryptoJS.enc.Base64.stringify(hash);
        codeChallenge = base64Code
            .replace(/\+/g, '-')
            .replace(/\//g, '_')
            .replace(/=/g, '');
    }

    return codeChallenge;
}

async function getUserData(access_token: string, token_type: string) {
    try {
        const res: any = await getUserDataApi(baseUserInfoUrl + userInfoApi, token_type, access_token);

        if (Array.isArray(res) && 0 < res.length) {
            return handelUserInfoData(res);
        }
    } catch (error) {
        debugInfo(error);
    }
}

async function getToken(code: string, randomString: string) {
    const queryParams = {
        client_id: clientIdConfig,
        grant_type: grantTypeConfig,
        code,
        code_verifier: randomString,
    };

    const url = handelGetUrl(baseUrl, tokenApi, queryParams, true);

    try {
        const data = await getTokenApi(url);

        if (data?.access_token) {
            return await getUserData(data.access_token, data.token_type);
        }
    } catch (error) {
        debugInfo(error);
    }
}

export async function getUserInfo() {
    const queryParams = {
        client_id: clientIdConfig,
        scope: scopeConfig,
        code_challenge: '',
        code_challenge_method: codeChallengeMethodConfig,
        prompt: promptConfig,
        response_type: responseTypeConfig,
        client_secret: clientSecretConfig,
    };

    try {
        const randomString = generateRandomString();

        const codeChallenge = codeChallengeGenerator(randomString);
        queryParams.code_challenge = codeChallenge;

        const url = handelGetUrl(baseUrl, mintApi, queryParams, true);

        const code = await getUrlCodeApi(url);

        if (code) {
            return await getToken(code, randomString);
        }
    } catch (error) {
        debugInfo(error);
    }
}
